import React from "react";
import { MDXProvider } from "@mdx-js/react"
import { MDXRenderer } from "gatsby-plugin-mdx";
import { SubTitle } from './SubTitle';
import { PostCard } from './PostCard';
import { PageCard } from './PageCard';
import { AdLink } from './AdLink';
import { AdBookLink } from './AdBookLink';
import { BackgroundColor } from './BackgroundColor';
import { ProductSubTitle } from './ProductSubTitle';
import { ProductCard } from './ProductCard';
import { ColorChart } from './ColorChart';
import { ContactButton } from './ContactButton';
import { SimpleSubTitle } from './SimpleSubTitle';
import { ButtonLink } from './ButtonLink';
//import { A8H90 } from "../components/A8H90";
import Link from './Link';
import { Quote } from './Quote';
//import { AdSenseWAutoH90 } from "./AdSenseWAutoH90";

const createComponents = (title, count, category) => {
  return {
    //h2: props => (
    //  <>
    //    //<AdSense />
    //    <h2 {...props} />
    //  </>
    //),
    h2: props => (
      <>
        {
          // count % 2 === 0 && count > 0 && <AdSenseWAutoH90 />
        }
        {
          // count++ % 2 === 1 && count > 0 && <A8H90 category={category} />
        }
        <SubTitle>{props.children}</SubTitle>
      </>
    ),
    a: props => (
      <>
        <Link {...props} isDecoration={`none`} />
      </>
    ),
    img: props => (
      <>
        <img alt={`${props.alt}｜${title}`} src={props.src} />
      </>
    ),
    PostCard,
    PageCard,
    AdLink,
    AdBookLink,
    Link,
    Quote,
    BackgroundColor,
    ProductSubTitle,
    ProductCard,
    ContactButton,
    SimpleSubTitle,
    ButtonLink,
    ColorChart,
  }
}

export const MDX = ({ title, siteUrl, tags, columns, body, category }) => {
  let count = 0;
  return (
    <MDXProvider components={createComponents(title, count, category)}>
      <MDXRenderer siteUrl={siteUrl} tags={tags} columns={columns}>{body}</MDXRenderer>
    </MDXProvider>
  );
};
